<template>
  <div>
    <BidsAddBulkPricingTableActionWrapper @clearSelection="clearSelection" />

    <LbTable
      :selection="selectedKeywords"
      has-selection
      :columns="columns"
      :data="bidsData"
      :row-id-fn="rowIdFn"
      :clear-selection-controller="clearSelectionController"
      @update:selection="setSelectedKeywords"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  BULK_IMPORT_BIDS,
  BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
} from '@/store/types';
import createController from '@/utils/controller';

import LbTable from '../../../../../common/LbTable';
import BidsAddBulkPricingTableActionWrapper from './BidsAddBulkPricingTableActionWrapper';
import BidsAddBulkPricingTableActionColumn from './columns/BidsAddBulkPricingTableActionColumn';
import BidsAddBulkPricingTableMatchTypeColumn from './columns/BidsAddBulkPricingTableMatchTypeColumn';
import BidsAddBulkPricingTablePriceOfferColumn from './columns/BidsAddBulkPricingTablePriceOfferColumn';

export default {
  name: 'BidsAddBulkPricingTable',
  components: {
    LbTable,
    BidsAddBulkPricingTableActionWrapper,
  },
  computed: {
    ...mapGetters({
      bidsData: BULK_IMPORT_BIDS,
      selectedKeywords: BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
    }),
    clearSelectionController() {
      return createController('clearSelection');
    },
    columns() {
      return [
        {
          label: this.$t('ADVERTISEMENT.KEYWORD'),
          property: 'keyword',
        },
        {
          label: this.$t('ADVERTISEMENT.BID.MAX_CPI'),
          property: 'priceOffer',
          component: BidsAddBulkPricingTablePriceOfferColumn,
        },
        {
          label: this.$t('ADVERTISEMENT.BID.MATCH_TYPE'),
          property: 'matchType',
          component: BidsAddBulkPricingTableMatchTypeColumn,
        },

        {
          label: this.$t('ACTION'),
          property: 'action',
          component: BidsAddBulkPricingTableActionColumn,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      setSelectedKeywords: BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
    }),
    rowIdFn({ keyword }) {
      return keyword;
    },
    clearSelection() {
      this.clearSelectionController.clearSelection();
    },
  },
};
</script>
